import { render, staticRenderFns } from "./download-verification-code.vue?vue&type=template&id=251ea1eb&scoped=true&"
import script from "./download-verification-code.vue?vue&type=script&lang=js&"
export * from "./download-verification-code.vue?vue&type=script&lang=js&"
import style0 from "./download-verification-code.vue?vue&type=style&index=0&id=251ea1eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ea1eb",
  null
  
)

export default component.exports